import styled, {css} from "styled-components";
import {Color} from "../../../../../common/utils/color-util";
import {HEADER_Z_INDEX} from "../../header-consts";

export const HeaderNavbarContainerDefaultBox = styled.div<{stickyOffset: number; useSafeAreaTop: boolean}>`
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  background-color: ${props => props.theme.colors.backgroundDark};
  /* background-color: ${props => Color.fromHex(props.theme.colors.backgroundDark, 0.6).hexa()};
  backdrop-filter: blur(6px); */
  position: sticky;
  top: ${({stickyOffset}) => stickyOffset + "px"};
  z-index: ${HEADER_Z_INDEX};
  ${({useSafeAreaTop}) => useSafeAreaTop ? css`padding-top: env(safe-area-inset-top);` : ''}

  padding: 0.5rem 2rem;
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    ${({useSafeAreaTop}) => useSafeAreaTop 
                ? css`padding: calc(env(safe-area-inset-top) + 0.5rem) 1rem 0.5rem 1rem;` 
                : css`padding: 0.5rem 1rem;`
    }
    
    border-bottom: 1px solid ${props => props.theme.colors.brandPrimary};
  }
`;
